<template>
  <section class="recommend-container">
    <div class="tab-container">
      <ul class="clearfix">
        <li v-for="(item, index) in tabs" :key="index" :class="{'active': item.value === this.activeName}" @click="toggleTab(item.value)" mars_sead="vschool_shouyepeizhi_recommend_link" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'recommend': item.value, 'recommendDesc': item.label })">
          {{item.label}}
          <span class="line"></span>
        </li>
      </ul>
    </div>
    <div class="list-container">
      <view-container :loading="loading" :empty="empty" :error="error" @retry="loadData">
        <ul>
          <li v-for="(item, index) in recommendationList" :key="index">
            <dl>
              <dt>
                <a :href="item.link" target="_blank" mars_sead="vschool_shouyepeizhi_recommend_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'recommend': this.activeName, 'position': index + 1})">
                  <imgWrap :src="item.coverUrl" width="304" height="194" :alt="item.title" :item="item" :pic="'coverUrl'"/>
                </a>
              </dt>
              <dd>
                <p class="list-title">
                  <a :href="item.link" target="_blank" mars_sead="vschool_shouyepeizhi_recommend_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'recommend': this.activeName, 'position': index + 1})">
                    {{item.title}}
                  </a>
                </p>
                <p class="list-tips">
                  <span v-if="item.duration">
                    时长
                    {{parseDuration(item.duration)}}
                  </span>
                  
                  <!-- <span v-if="item.hot">
                    <i class="eye-icon"></i>
                    {{item.hot}}
                  </span> -->
                  <span v-if="item.learningCount > 0" style="font-size:12px; color:#999;">
                    {{item.learningCount}}人学习 
                  </span>
                  <span v-if="item.avgRating > 0" style="font-size:12px; color:#FD3374;" class="avg-rating">
                    {{item.avgRating}}分
                  </span>
                </p>
              </dd>
            </dl>
          </li>
        </ul>
      </view-container>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import pic from '../../assets/img/production-pic.png'
import util from '@/util/index.js'
import imgWrap from '@/components/imgWrap'
export default {
  name: '',
  data () {
    return {
      pic,
      activeName: 1,
      tabs: [
        {
          label: '热门推荐',
          value: 1
        },
        {
          label: '新上课程',
          value: 2
        },
        {
          label: '短视频课程',
          value: 3
        }
      ],
      loading: false,
      empty: false,
      error: false,
      hasPermission: false
    }
  },
  computed: {
    ...mapState(['recommendationList', 'sessionTarget', 'queryUserPromise'])
  },
  mounted () {
    this.queryUserPromise.then(() => {
      this.loadData()
    })
  },
  methods: {
    loadData () {
      this.loading = true
      this.empty = false
      this.error = false
      this.queryRecommendationDetails(this.activeName).then(() => {
        this.loading = false
        if (!this.recommendationList.length) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    toggleTab (activeName) {
      this.activeName = activeName
      this.loadData()
    },
    ...mapActions(['queryRecommendationDetails']),
    parseDuration: util.parseDuration
  },
  components: {
    imgWrap
  }
}
</script>

<style lang="scss" scoped>
.recommend-container {
  .tab-container {
    margin-top: 40px;
    ul {
      text-align: center;
      li {
        display: inline-block;
        color: #666;
        font-size: 24px;
        line-height: 34px;
        margin: 0 35px;
        position: relative;
        cursor: pointer;
        .line {
          position: absolute;
          left: 50%;
          top:100%;
          width: 20px;
          height: 3px;
          background: #FF2F5D;
          margin-top: 10px;
          margin-left: -10px;
          display: none;
        }
      }
      .active {
        color: #333;
        font-weight: 600;
        .line {
          display: block;
        }
      }
    }
  }
  .list-container {
    margin-top: 45px;
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -16px;
      margin-right: -16px;
      li{
        flex: 0 0 25%;
        margin-bottom: 32px;
      }
    }
    dl {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      margin: 0 16px;
      height: 100%;
      dt {
        height: 194px;
      }
      dd {
        font-size: 16px;
        line-height: 22px;
        color: #333;
        font-weight: bold;
        padding-left: 16px;
        padding-top: 8px;
        .list-title {
          width: 274px;
          height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: normal;
          padding-top: 6px;
          padding-bottom: 3px;
        }
        p.list-tips {
          font-size: 12px;
          font-weight: normal;
          color: #666;
          text-align: right;
          font-family: Arial, Helvetica, sans-serif;
          padding-top: 5px;
          padding-bottom: 5px;
          padding-right: 16px;
          .eye-icon {
            background: url(../../assets/img/search_icon_show@2x.png) no-repeat;
            background-size: 14px;
            display: inline-block;
            width: 14px;
            height: 12px;
            margin-left: 16px;
          }
        }
      }
    }
  }
}
</style>
